import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["data-window-id"]
const _hoisted_2 = { class: "content-window-title" }
const _hoisted_3 = { class: "content-window-controls" }
const _hoisted_4 = ["data-bs-title", "aria-label"]
const _hoisted_5 = ["data-bs-title", "aria-label"]
const _hoisted_6 = ["data-bs-title", "aria-label"]
const _hoisted_7 = {
  ref: "frameHost",
  class: "content-window-body"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["content-window", { 'is-maximized': $props.windowState.maximized }]),
    style: _normalizeStyle($setup.windowStyle),
    "data-window-id": $props.windowState.id,
    onMousedown: _cache[11] || (_cache[11] = $event => ($setup.emit('focus')))
  }, [
    _createElementVNode("header", {
      class: "content-window-header",
      onMousedown: $setup.onHeaderMouseDown
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString($props.windowState.title), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "content-window-btn content-window-btn-minimize",
          "data-bs-toggle": "tooltip",
          "data-bs-title": $setup.label('minimize', 'Minimize'),
          "aria-label": $setup.label('minimize', 'Minimize'),
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($setup.emit('minimize')), ["stop"]))
        }, [...(_cache[12] || (_cache[12] = [
          _createElementVNode("i", { class: "bi bi-dash-lg" }, null, -1 /* CACHED */)
        ]))], 8 /* PROPS */, _hoisted_4),
        _createElementVNode("button", {
          type: "button",
          class: "content-window-btn content-window-btn-maximize",
          "data-bs-toggle": "tooltip",
          "data-bs-title": $setup.label($props.windowState.maximized ? 'restore' : 'maximize', $props.windowState.maximized ? 'Restore' : 'Maximize'),
          "aria-label": $setup.label($props.windowState.maximized ? 'restore' : 'maximize', $props.windowState.maximized ? 'Restore' : 'Maximize'),
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($setup.emit('toggle-maximize')), ["stop"]))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass($props.windowState.maximized ? 'bi bi-fullscreen-exit' : 'bi bi-fullscreen')
          }, null, 2 /* CLASS */)
        ], 8 /* PROPS */, _hoisted_5),
        _createElementVNode("button", {
          type: "button",
          class: "content-window-btn content-window-btn-close",
          "data-bs-toggle": "tooltip",
          "data-bs-title": $setup.label('close', 'Close'),
          "aria-label": $setup.label('close', 'Close'),
          onClick: _cache[2] || (_cache[2] = _withModifiers($event => ($setup.emit('close')), ["stop"]))
        }, [...(_cache[13] || (_cache[13] = [
          _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1 /* CACHED */)
        ]))], 8 /* PROPS */, _hoisted_6)
      ])
    ], 32 /* NEED_HYDRATION */),
    _createElementVNode("div", _hoisted_7, null, 512 /* NEED_PATCH */),
    (!$props.windowState.maximized)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            class: "content-window-resize content-window-resize-n",
            onMousedown: _cache[3] || (_cache[3] = $event => ($setup.onResizeMouseDown($event, 'n')))
          }, null, 32 /* NEED_HYDRATION */),
          _createElementVNode("div", {
            class: "content-window-resize content-window-resize-s",
            onMousedown: _cache[4] || (_cache[4] = $event => ($setup.onResizeMouseDown($event, 's')))
          }, null, 32 /* NEED_HYDRATION */),
          _createElementVNode("div", {
            class: "content-window-resize content-window-resize-e",
            onMousedown: _cache[5] || (_cache[5] = $event => ($setup.onResizeMouseDown($event, 'e')))
          }, null, 32 /* NEED_HYDRATION */),
          _createElementVNode("div", {
            class: "content-window-resize content-window-resize-w",
            onMousedown: _cache[6] || (_cache[6] = $event => ($setup.onResizeMouseDown($event, 'w')))
          }, null, 32 /* NEED_HYDRATION */),
          _createElementVNode("div", {
            class: "content-window-resize content-window-resize-ne",
            onMousedown: _cache[7] || (_cache[7] = $event => ($setup.onResizeMouseDown($event, 'ne')))
          }, null, 32 /* NEED_HYDRATION */),
          _createElementVNode("div", {
            class: "content-window-resize content-window-resize-nw",
            onMousedown: _cache[8] || (_cache[8] = $event => ($setup.onResizeMouseDown($event, 'nw')))
          }, null, 32 /* NEED_HYDRATION */),
          _createElementVNode("div", {
            class: "content-window-resize content-window-resize-se",
            onMousedown: _cache[9] || (_cache[9] = $event => ($setup.onResizeMouseDown($event, 'se')))
          }, null, 32 /* NEED_HYDRATION */),
          _createElementVNode("div", {
            class: "content-window-resize content-window-resize-sw",
            onMousedown: _cache[10] || (_cache[10] = $event => ($setup.onResizeMouseDown($event, 'sw')))
          }, null, 32 /* NEED_HYDRATION */)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ], 46 /* CLASS, STYLE, PROPS, NEED_HYDRATION */, _hoisted_1))
}